import { Flex, IconButton, Text } from '@driftt/dds'
import { faGripDotsVertical } from '@driftt/dds.icons/regular/faGripDotsVertical'
import React, { Children, ReactNode } from 'react'

interface TableHeaderRow {
  label: string | null
  value: string
}

interface TableHeaderProps {
  headerRow: TableHeaderRow[]
  tableSizing: string[]
}

interface TableContentProps {
  children: ReactNode
  tableSizing: string[]
  isDragAndDropEnable: boolean
}

type AttributesDragAndDropTableProps = TableHeaderProps & TableContentProps

// Partly used in Attributes.tsx
export const TableHeader = ({ headerRow, tableSizing }: TableHeaderProps) => (
  <Flex
    as="header"
    fullWidth
    css={{ backgroundColor: '$blue1', padding: '0 0 0 $1' }}
  >
    {headerRow.map(({ label, value }, idx) => {
      return (
        <Text
          key={value}
          variant="body"
          css={{
            width: '30%',
            maxWidth: tableSizing[idx],
            padding: '$1',
            fontWeight: '600',
            fontSize: '$thead',
          }}
        >
          {label}
        </Text>
      )
    })}
  </Flex>
)

const TableContent = ({
  tableSizing,
  isDragAndDropEnable,
  children,
}: TableContentProps) => {
  const childrenArray = Children.toArray(children)

  return (
    <Flex fullWidth direction="column" gap={0}>
      {childrenArray.map((childrenRow, idx) => {
        return (
          <Flex
            key={`${tableSizing[idx]}--${idx}`}
            fullWidth
            css={{
              padding: 'calc($1 - 4px) $2', // Forcing equal padding
              borderBottom: '1px solid $gray3',
              '&:last-child': {
                borderBottom: 'none',
              },
            }}
          >
            {isDragAndDropEnable ? (
              <Flex gap={0} css={{ width: '100%', maxWidth: tableSizing[0] }}>
                <IconButton
                  title="change order"
                  icon={faGripDotsVertical}
                  css={{ cursor: 'grab', marginTop: '$1' }}
                  onClick={() => console.log('change order')}
                />
              </Flex>
            ) : null}

            <Flex gap={0}>{childrenRow}</Flex>
          </Flex>
        )
      })}
    </Flex>
  )
}

// Not in use for now,
// TODO: finish the implementation for DDS usage
export const AttributesDragAndDropTable = ({
  headerRow,
  children,
  tableSizing,
  isDragAndDropEnable,
}: AttributesDragAndDropTableProps) => {
  console.log(children, 'children')

  return (
    <Flex fullWidth direction="column" gap={0}>
      <TableHeader headerRow={headerRow} tableSizing={tableSizing} />
      <TableContent
        children={children}
        tableSizing={tableSizing}
        isDragAndDropEnable={isDragAndDropEnable}
      />
    </Flex>
  )
}
